import { colors } from "../../lib/colors"
import styled from "styled-components"

interface NOTIFYTEXT_STYLED_PROPS {
  textColor?: string
  position?: string
  fadeIn?: boolean
}

export const Notifytext = styled.div<NOTIFYTEXT_STYLED_PROPS>`
  position: absolute;
  width: 100%;
  text-align: center;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "GT America, regular";
  z-index: 2;
  top: ${({ position }) => (position === "top" ? "-35px" : "72%")};
  ${({ fadeIn }) =>
    fadeIn
      ? "opacity: 1; transform: translateY(0px);"
      : "opacity: 0; transform: translateY(10px)"};
  color: ${({ color }) =>
    color ? colors.secondary : colors.secondaryBackground};
  transition-duration: ${({ fadeIn }) => (fadeIn ? "0.3s" : "0.167s")};
  transition-timing-function: linear;
  transition-property: opacity, transform;
  white-space: nowrap;
  p {
    font-family: "GT America, regular";
    font-weight: 900;
  }
  svg {
    height: 16px;
    width: 16px;
    margin: 0;
    path {
      stroke: ${colors.secondary};
    }
  }
`
